export default __webpack_public_path__ + "images/0x56659245931cb6920e39c189d2a0e7dd0da2d57b.png";